'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _actionTypes = require('../actionTypes');

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getDefaultState = exports.getDefaultState = function getDefaultState() {
  return {
    localTransactions: {}
  };
};

var updateTransaction = function updateTransaction(state, txHash, modifier) {
  return _extends({}, state, {
    localTransactions: _extends({}, state.localTransactions, _defineProperty({}, txHash, modifier(state.localTransactions[txHash] || {})))
  });
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultState();
  var action = arguments[1];

  switch (action.type) {
    case _actionTypes.TRANSACTION_CREATED:
      return updateTransaction(state, action.transactionHash, function (transaction) {
        return _extends({}, transaction, {
          id: action.id,
          actionType: action.actionType,
          created: (0, _moment2.default)().unix(),
          updated: (0, _moment2.default)().unix(),
          status: _constants.TransactionStatusEnum.pending,
          transactionHash: action.transactionHash,
          label: action.label,
          notificationId: 0
        });
      });

    case _actionTypes.TRANSACTION_PROGRESS_NOTIFIED:
      return updateTransaction(state, action.transactionHash, function (transaction) {
        return _extends({}, transaction, {
          notificationId: action.notificationId
        });
      });

    case _actionTypes.TRANSACTION_RECEIPTS_FETCHED:
      return action.transactionReceipts.filter(function (receipt) {
        return state.localTransactions[receipt.transactionHash];
      }).reduce(function (localState, receipt) {
        return updateTransaction(localState, receipt.transactionHash, function (transaction) {
          return _extends({}, transaction, {
            status: Number(receipt.status),
            updated: (0, _moment2.default)().unix()
          });
        });
      }, _extends({}, state));

    case _actionTypes.LOCAL_TRANSACTION_DISCARDED:
      return _extends({}, state, {
        localTransactions: (0, _lodash.omit)(state.localTransactions, action.transactionHash)
      });

    default:
      return state;
  }
};

exports.default = reducer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/reducers/transactions.js
// module id = 1316
// module chunks = 0